import { ButtonLink, ButtonSize } from '@farmasiet/frontendcore-reactcomponents';
import * as React from 'react';

import { getTranslation, keys } from '../../../../../Resources/Translations';

interface IFavouriteProductsEmpty {
    readonly searchUrl: string;
}

export const FavouriteProductsEmpty = (props: IFavouriteProductsEmpty) => {
    return (
        <div className="FavouritesPage__Empty">
            <img src="/dist/assets/images/empty-favourites.svg" alt="empty cart icon" className="FavouritesPage__Image" loading="lazy" />
            <h1>{getTranslation(keys['favourites.saveItems'])}</h1>
            <p>{getTranslation(keys['favourites.description'])}</p>
            <ButtonLink size={ButtonSize.Medium} href={props.searchUrl} className="FavouritesPage__Button">
                {getTranslation(keys['favourites.seeAllProducts'])}
            </ButtonLink>
        </div>
    );
};
